import React from 'react';

const ErrorMessage = ({message}) => {
  return message && message.length ? (<p>{message}</p>) : null;
};

export default ErrorMessage;
